import { Permission } from './Permission.model';
import { ModuleCV } from '@app/shared/model/cv/ModuleCV';
import { EntityCV } from '@app/shared/model/cv/EntityCV.model';

export class PermissionCV {

    public static all: PermissionCV = new PermissionCV();

    // public ADMINISTRATION = 'administrator';
    // public OPERATOR = 'operator';
    // public AIRPORT = 'airport';
    // public AIRCRAFT = 'aircraft';
    // public AIRCRAFT_TYPE = 'aircraftType';
    // public SERVICE_TYPE = 'serviceType';
    // public COUNTRY = 'country';
    // public USER = 'user';
    // public MANAGEMENT = 'management';
    // public ROLE = 'role';
    // public PERMISSION = 'permission';
    // public SCHEDULE = 'schedule';
    // public COORDINATION = 'coordination';
    // public INITIAL_COORDINATION = 'initialCoordination';
    // public SEASON_COORDINATION = 'seasonCoordination';
    // public SEASON = 'season';
    // public AIRPORT_SEASON = 'airportSeason';
    // public GROUP = 'group';
    // public RESTRICTION = 'restriction';
    // public TELEX = 'telex';
    // public PARAMETER = 'parameter';

    ADMINISTRATION: Permission = new Permission(ModuleCV.all.ADMINISTRATION);
    OPERATOR: Permission = new Permission('operator');
    AIRPORT: Permission = new Permission('airport');
    AIRCRAFT: Permission = new Permission('aircraft');
    AIRCRAFT_TYPE: Permission = new Permission('aircraftType');
    SERVICE_TYPE: Permission = new Permission('serviceType');
    COUNTRY: Permission = new Permission(EntityCV.all.COUNTRY.toLowerCase());
    USER: Permission = new Permission('user');
    MANAGEMENT: Permission = new Permission('management');
    ROLE: Permission = new Permission('role');
    PERMISSION: Permission = new Permission('permission');
    SCHEDULE: Permission = new Permission('schedule');
    COORDINATION: Permission = new Permission('coordination');
    // INITIAL_COORDINATION: Permission = new Permission('initialCoordination');
    INITIAL_COORDINATION: Permission = new Permission('iniCoordPhase');
    SEASON_COORDINATION: Permission = new Permission('seasonCoordination');
    SEASON: Permission = new Permission('season');
    AIRPORT_SEASON: Permission = new Permission('airportSeason');
    GROUP: Permission = new Permission('group');
    RESTRICTION: Permission = new Permission('restriction');
    TELEX: Permission = new Permission('telex');
    PARAMETER: Permission = new Permission('parameter');
    SEND_EMAIL: Permission = new Permission('sendEmail');
	INI_COORD_PHASE: Permission = new Permission('iniCoordPhase');
    SLOT_MONITORING: Permission = new Permission('slotMonitoring');
    INITIAL_COORDINATION_REQUEST_MANAGEMENT: Permission = new Permission('initialCoordinationRequestMng');
    // OPERATION_FLIGHT: Permission = new Permission('operationFlight');

    FLIGHT: Permission = new Permission(EntityCV.all.FLIGHT.toLocaleLowerCase());
    ACTION_CODE: Permission = new Permission('action');
    FLIGHT_CATEGORY: Permission = new Permission('flightCategory');
    // FLIGHT_CATEGORY: Permission = new Permission('flight');
    WORK_CALENDAR: Permission = new Permission('workCalendar');
    REJECTION_REASON: Permission = new Permission('rejectionReason');
    // REJECTION_REASON: Permission = new Permission('telex');
    MAILBOX: Permission = new Permission('mailbox');
    // MAILBOX: Permission = new Permission('telex');
    USER_FACILITIES: Permission = new Permission('userFacilities');
    OPERATIONAL_FLIGHT: Permission = new Permission('operationalFlight');
    PENDING_CRITERIA: Permission = new Permission('pendingCriteria');
    PENDING_CRITERIA_APPLICATION: Permission = new Permission('pendingCriteriaApplication');
    ASSOCIATED_FLIGHT: Permission = new Permission('associatedFlight');
    SHARED_OPERATION_RESTRICTION: Permission = new Permission('sharedOperationRestriction');
    SHARED_OPERATION: Permission = new Permission('sharedOperation');
    FLIGHT_MONITORING: Permission = new Permission('flightMonitoring');
    PORTAL_FILTER: Permission = new Permission('portalFilter');
    PORTAL_METHOD_3: Permission = new Permission("portalMethod3");
    CRITICAL_FLIGHT: Permission = new Permission("criticalFlight");
    AIRPORT_OPERATOR_LAYOVER_EXCEPTION: Permission = new Permission("airportOperatorLayoverException");
    PENDING_NP: Permission = new Permission('pendingNP');
    

    constructor() {
    }
}
